// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 493 ? "bf5f3635" : chunkId) + "." + {"289":"e4fc96bf6244e103","493":"a4714d1739abf076"}[chunkId] + ".js";
};